import React from "react";

const Cube3dIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width={props.width || 48}
    height={props.height || 48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <polygon points="24,4 44,14 44,34 24,44 4,34 4,14" stroke="currentColor" strokeWidth="2" fill="none" />
      <polyline points="24,4 24,24 44,14" stroke="currentColor" strokeWidth="2" fill="none" />
      <polyline points="24,24 4,14" stroke="currentColor" strokeWidth="2" fill="none" />
      <polyline points="24,24 24,44" stroke="currentColor" strokeWidth="2" fill="none" />
    </g>
  </svg>
);

export default Cube3dIcon;